import { apiPaths } from '@percent/cause-dashboard/services/apiPaths'
import type { AxiosInstance } from 'axios'

type ProductOffersServiceCapabilities = {
  percentClient: AxiosInstance
}

export type TrackProductOfferClickPayload = {
  offerId: string
  program: string
}

export const productOffersService = ({ percentClient }: ProductOffersServiceCapabilities) => ({
  trackProductOfferClick: ({ offerId, program }: TrackProductOfferClickPayload) =>
    percentClient.post(apiPaths.v1ProductOfferClick, { offerId, program })
})
